"use client";

import { type ReactNode, useEffect } from "react";
import { analytics, initAnalytics } from "@/lib/analytics/segment";

interface Props {
  writeKey: string;
  children: ReactNode;
}

export function AnalyticsProvider({ writeKey, children }: Props) {
  useEffect(() => {
    initAnalytics(writeKey);

    // Bridge window.analytics for backward compatibility with sg-frontend-common SegmentHelper
    window.analytics = analytics;
  }, [writeKey]);

  return children;
}
